// Set to true to show SaaS UI elements, false to hide them
export const SHOW_SAAS_UI_ELEMENTS = false;

// Set to true to show Google Sign-in buttons, false to hide them
export const SHOW_GOOGLE_SIGNIN = false;